import { privatePageMetadata } from "@/lib/seo";
import { createFileRoute } from "@tanstack/react-router";
import { Bell, CheckCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useNotifications, notificationTitle } from "@/hooks/useNotifications";
import { useT } from "@/i18n";
import { PushToggle } from "@/components/push-toggle";

export const Route = createFileRoute("/app/notifications")({
  head: () =>
    privatePageMetadata(
      "/app/notifications",
      "Notifications | BeHot.Now",
      "Your BeHot.Now account notifications.",
    ),
  component: NotificationsPage,

});

function NotificationsPage() {
  const { t } = useT();
  const { items, unread, markAllRead, markRead, isLoading } = useNotifications(100);

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="font-display text-2xl font-bold">{t("messaging.notifications")}</h2>
          <p className="text-sm text-muted-foreground">{t("messaging.notificationsIntro")}</p>
        </div>
        {unread > 0 && (
          <Button variant="outline" size="sm" onClick={() => void markAllRead()}>
            <CheckCheck className="size-4" /> {t("messaging.markAllRead")}
          </Button>
        )}
      </div>

      <PushToggle />

      {isLoading && <p className="text-sm text-muted-foreground">{t("messaging.loading")}</p>}

      {!isLoading && items.length === 0 && (
        <Card className="flex flex-col items-center gap-2 p-10 text-center">
          <Bell className="size-6 text-muted-foreground" />
          <p className="text-sm text-muted-foreground">{t("messaging.noNotifications")}</p>
        </Card>
      )}

      <div className="space-y-2">
        {items.map((n) => (
          <a
            key={n.id}
            href={n.url ?? "#"}
            onClick={() => void markRead(n.id)}
            className={`block rounded-xl border border-border p-4 transition-colors hover:bg-muted ${
              n.read_at ? "" : "border-primary/40 bg-primary/5"
            }`}
          >
            <div className="flex items-start justify-between gap-3">
              <div>
                <p className="font-medium">{notificationTitle(n, t)}</p>
                {n.body && <p className="mt-0.5 text-sm text-muted-foreground">{n.body}</p>}
              </div>
              <span className="shrink-0 text-xs text-muted-foreground">
                {new Date(n.created_at).toLocaleString()}
              </span>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}
